import React from 'react'
import RentHome from '../../../views/Insurance/RentDefault/RentHome'

const RentInsurance = () => {
  return (
    <RentHome/>
  )
}

export default RentInsurance